import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn } from "arv-reactcomponents";

const ListingSearchBar = ({ totalElements, queryApplied }) => {
  if (!queryApplied) return null;
  return (
    <Fragment>
      <GridRow className="nw-listing-resultsforquery">
        <GridColumn>
          {totalElements} results found for &quot;
          {queryApplied}
          &quot;
        </GridColumn>
      </GridRow>
    </Fragment>
  );
};

ListingSearchBar.propTypes = {
  totalElements: PropTypes.number.isRequired,
  queryApplied: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ListingSearchBar,
  component: ListingSearchBar,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ListingSearchBar/index.js